import React from "react";

const Alert = ({ tone = "info", children, role, className = "", ...rest }) => (
  <div
    className={`alert alert--${tone}${className ? " " + className : ""}`}
    role={role || (tone === "danger" ? "alert" : undefined)}
    {...rest}
  >
    <div className="alert__body">{children}</div>
  </div>
);

export default Alert;
